import { render, staticRenderFns } from "./CompanySwitch.vue?vue&type=template&id=5b08e822&scoped=true&lang=html&"
import script from "./CompanySwitch.vue?vue&type=script&lang=js&"
export * from "./CompanySwitch.vue?vue&type=script&lang=js&"
import style0 from "./CompanySwitch.vue?vue&type=style&index=0&id=5b08e822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08e822",
  null
  
)

export default component.exports